import { SET_CAROUSEL_START_POSITION } from 'redux/modules/slot-booking/actions/types';
import { CAROUSEL_NONE } from 'constants/carouselSlidePosition';

export const resetCarouselStartPosition = () => ({
  type: SET_CAROUSEL_START_POSITION,
  carouselStartPosition: CAROUSEL_NONE,
});
